
import { Options, Vue } from "vue-class-component";
import FloatingActionButton from "@/components/FloatingActionButton/FloatingActionButton.vue";
import LogoMain from '@/components/LogoMain/LogoMain.vue';
import BaseModal from '@/components/BaseModal/BaseModal.vue';
import { MenuStore, ModalStore } from '@/store/index';
import { translate } from "@/helpers/locale-helper";
import {LocaleStore} from "@/store/index";
import {ITranslatable} from "@/models/vimy.models";

export interface ISideMenuItem {
  text: string;
  url?:  ITranslatable<string>;
  name?: string;
  action?: Function
}

@Options({
  components: {
    FloatingActionButton,
    LogoMain,
    BaseModal
  },
  props: {}
})

export default class SideMenu extends Vue {
  declare $refs: {
    menu: HTMLElement;
  };

  menuUnwatch!: Function;
  credits: boolean = false;
  closed: boolean = true;

  items: ISideMenuItem[] = [
    {
      text: 'navigation.about',
      action: function () {
        ModalStore.setCreditModalState('about');
        MenuStore.close();
        ModalStore.openCredits();
      }
    },
    {
      text: 'navigation.credits',
      action: function () {
        ModalStore.setCreditModalState('credits');
        MenuStore.close();
        ModalStore.openCredits();
      }
    },
    {
      text: 'navigation.lift',
      url: LocaleStore.data.navigation.lift_url
    },
    {
      text: 'navigation.change_language',
      action: function (component: SideMenu) {
        // no idea why but this is not the correct this
        component.toggleLocale()
      }
    }
  ];

  toggleLocale() {
    this.$i18n.locale = this.$i18n.locale === 'fr' ? 'en' : 'fr';
    localStorage.setItem('locale', this.$i18n.locale);
  }

  bindAction(item: ISideMenuItem) {
    return item.action ? 'click' : null;
  }

  isClosed(): boolean {
    return !this.$refs.menu?.classList.contains('menu-open');
  }

  toggle() {
    if (this.isClosed()) {
      this.open();
      return;
    }

    this.close();
  }

  getItemUrl( item : ISideMenuItem) {
  return   translate(this.$i18n.locale, 'navigation.lift_url');
  }

  private open() {
    this.$refs.menu.classList.add("menu-open");
    this.closed = false;
  }

  private close() {
    this.$refs.menu.classList.remove("menu-open");
    this.closed = true;
  }

  onCreditClosed() {
    this.credits = false;
  }

  mounted() {
    this.menuUnwatch = MenuStore.$watch(
      (store) =>
        store.closes,
      (value, legacyValue) => {
        this.close();
      }
    );
  }

  unmounted() {
    if (this.menuUnwatch)
      this.menuUnwatch();
  }
}
